import SvgDocument from '@img/icons/document.svg';
import SvgGuide from '@img/icons/guide.svg';
import SvgLock from '@img/icons/lock.svg';
import SvgChevron from '@img/icons/menu-chevron-right.svg';
import SvgUnlock from '@img/icons/unlock.svg';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './TechnicalDocumentCard.styles';
const TechnicalDocumentCard = ({ unlocked = false, ...props }) => {
    return (React.createElement(S.Outer, { "data-site": props.site, "data-featured": props.featured },
        React.createElement(S.Container, null,
            React.createElement(S.TypeContainer, null,
                React.createElement(S.LockContainer, null, !!unlocked || props.loggedIn ? React.createElement(SvgUnlock, null) : React.createElement(SvgLock, null)),
                React.createElement(S.Type, null, props.type === 'document' ? 'Technical Document' : 'How to Guide')),
            React.createElement(S.IconContainer, null,
                props.site === 'ess' && React.createElement(SvgChevron, null),
                React.createElement(S.Icon, null, props.type === 'document' ? React.createElement(SvgDocument, null) : React.createElement(SvgGuide, null))),
            React.createElement(S.ContentContainer, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.Description, null, props.description),
                React.createElement(S.CTAContainer, null,
                    React.createElement(S.CTA, null,
                        React.createElement(LinkButton, { buttonType: props.site === 'ess' ? 'secondary' : 'default', href: props.cta?.url, target: props.cta?.target, site: props.site }, props.cta?.text)),
                    !props.featured && (React.createElement(S.Count, null,
                        props.count,
                        " ",
                        props.type === 'document' ? 'Downloads' : 'Views')))))));
};
export default TechnicalDocumentCard;
